import { SvgIconProps } from "@mui/material";

// A tall main pane on the left, 2 small panes stacked on the right.
export const OneVertPlusTwoIcon = (props: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <rect x="2" y="2" width="9" height="20" rx="1.5" />
    <rect x="13" y="2" width="9" height="9" rx="1.2" />
    <rect x="13" y="13" width="9" height="9" rx="1.2" />
  </svg>
);
